import React, { useEffect, useRef } from 'react';
import { APIProvider, Map, useMap } from '@vis.gl/react-google-maps';
import { AdvancedMarker } from '@vis.gl/react-google-maps';
import { useColorScheme } from '@mui/material/styles';
import ImageMarker from './ImageMarker';
import CircularProgress from '@mui/material/CircularProgress';

function BatteryMapContent({ position, imageSrc, pinColor, loading }) {
  const googleMap = useMap();
  
  // Pan to new position when it changes
  useEffect(() => {
    if (googleMap) {
      googleMap.panTo(position);
    }
  }, [googleMap, position.lat, position.lng]);

  return (
    <AdvancedMarker position={position} onClick={() => {
      const url = `https://www.google.com/maps/dir/?api=1&destination=${position.lat},${position.lng}`;
      window.open(url, '_blank');
    }}>
      {loading && <CircularProgress />}
      <ImageMarker imageSrc={imageSrc} pinColor={pinColor} loading={loading} />
    </AdvancedMarker>
  );
}

function BatteryMap({ position: { lat, lng }, imageSrc, pinColor, loading }) {
  const { mode } = useColorScheme();
  const colorSchemeMap = { light: "LIGHT", dark: "DARK", system: "FOLLOW_SYSTEM" };
  const position = { lat, lng };

  return (
    <APIProvider apiKey="AIzaSyBrofpZ8fdySj8Hn5rOc6jepjSZemsjHRo">
      <Map
        mapContainerStyle={{ width: '100vw', height: '400px', borderRadius: '50px' }}
        defaultCenter={position}
        defaultZoom={15}
        gestureHandling={'greedy'}
        disableDefaultUI={true}
        mapId={'2d5d07f22b694022'}
        reuseMaps={true}
        colorScheme={colorSchemeMap[mode]}
      >
        <BatteryMapContent 
          position={position}
          imageSrc={imageSrc}
          pinColor={pinColor}
          loading={loading}
        />
      </Map>
    </APIProvider>
  );
}

export default React.memo(BatteryMap);